export default __webpack_public_path__ + "static/media/send_sc.2d818b3f.png";